import {AllRendererProps} from './AllRendererProps';

/**
 * @about Union of all elements of all types
 */
export type FullSchema = AllRendererProps;
